module.exports = __webpack_public_path__ + "img/500.0823f552.jpg";